var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-75.9,0.1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.219,0C80.219,-0 80.219,-0 80.219,-0C77.904,-0 76,1.905 76,4.219C76,5.002 76.218,5.771 76.63,6.437L79.979,11.837C80.043,11.94 80.157,12.003 80.279,12.003C80.402,12.003 80.516,11.938 80.579,11.832L83.842,6.38C84.231,5.727 84.437,4.98 84.437,4.22C84.437,1.906 82.533,0.001 80.219,0ZM83.239,6.019L80.272,10.973L77.227,6.067C76.883,5.511 76.7,4.87 76.7,4.216C76.7,2.286 78.288,0.698 80.218,0.698C82.148,0.698 83.736,2.286 83.736,4.216C83.736,4.851 83.565,5.474 83.239,6.019Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-9.641,-9.641)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.859,11.75C88.702,11.75 87.75,12.702 87.75,13.859C87.75,15.016 88.702,15.968 89.859,15.968C91.016,15.968 91.968,15.016 91.968,13.859C91.966,12.703 91.015,11.752 89.859,11.75ZM89.859,15.27C89.858,15.27 89.858,15.27 89.857,15.27C89.083,15.27 88.446,14.633 88.446,13.859C88.446,13.085 89.083,12.448 89.857,12.448C90.631,12.448 91.268,13.085 91.268,13.859C91.267,14.632 90.632,15.268 89.859,15.27Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.55a79865.svg";
export { ForwardRef as ReactComponent };